// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdjustmentSelectorController from "./adjustment_selector_controller"
application.register("adjustment-selector", AdjustmentSelectorController)

import Admin__ActivityChipsController from "./admin/activity_chips_controller"
application.register("admin--activity-chips", Admin__ActivityChipsController)

import Admin__GiftCardAmountController from "./admin/gift_card_amount_controller"
application.register("admin--gift-card-amount", Admin__GiftCardAmountController)

import Admin__GiftCardDomainController from "./admin/gift_card_domain_controller"
application.register("admin--gift-card-domain", Admin__GiftCardDomainController)

import Admin__RangePickerController from "./admin/range_picker_controller"
application.register("admin--range-picker", Admin__RangePickerController)

import Admin__StatsChartController from "./admin/stats_chart_controller"
application.register("admin--stats-chart", Admin__StatsChartController)

import AnalyticsClickController from "./analytics_click_controller"
application.register("analytics-click", AnalyticsClickController)

import AppBannerController from "./app_banner_controller"
application.register("app-banner", AppBannerController)

import BestsellersTrackerController from "./bestsellers_tracker_controller"
application.register("bestsellers-tracker", BestsellersTrackerController)

import BulkPriceController from "./bulk_price_controller"
application.register("bulk-price", BulkPriceController)

import BulkQuantityController from "./bulk_quantity_controller"
application.register("bulk-quantity", BulkQuantityController)

import CheckboxRevealController from "./checkbox_reveal_controller"
application.register("checkbox-reveal", CheckboxRevealController)

import Checkout__DeliveryFormController from "./checkout/delivery_form_controller"
application.register("checkout--delivery-form", Checkout__DeliveryFormController)

import Checkout__GlsParcelshopController from "./checkout/gls_parcelshop_controller"
application.register("checkout--gls-parcelshop", Checkout__GlsParcelshopController)

import ChoicesSelectController from "./choices_select_controller"
application.register("choices-select", ChoicesSelectController)

import ClassificationVariantsController from "./classification_variants_controller"
application.register("classification-variants", ClassificationVariantsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfiguratorStateController from "./configurator_state_controller"
application.register("configurator-state", ConfiguratorStateController)

import ConfiguratorSubmitResultController from "./configurator_submit_result_controller"
application.register("configurator-submit-result", ConfiguratorSubmitResultController)

import ConnectedSelectController from "./connected_select_controller"
application.register("connected-select", ConnectedSelectController)

import ContestDrawController from "./contest_draw_controller"
application.register("contest-draw", ContestDrawController)

import CookiePreferencesController from "./cookie_preferences_controller"
application.register("cookie-preferences", CookiePreferencesController)

import CurrencyConversionController from "./currency_conversion_controller"
application.register("currency-conversion", CurrencyConversionController)

import DashboardFilterController from "./dashboard_filter_controller"
application.register("dashboard-filter", DashboardFilterController)

import DesignPreviewController from "./design_preview_controller"
application.register("design-preview", DesignPreviewController)

import DialogOpenerController from "./dialog_opener_controller"
application.register("dialog-opener", DialogOpenerController)

import DirectUploaderController from "./direct_uploader_controller"
application.register("direct-uploader", DirectUploaderController)

import EnableFieldsController from "./enable_fields_controller"
application.register("enable-fields", EnableFieldsController)

import ExchangeRateController from "./exchange_rate_controller"
application.register("exchange-rate", ExchangeRateController)

import ExpandableListController from "./expandable_list_controller"
application.register("expandable-list", ExpandableListController)

import FileFieldController from "./file_field_controller"
application.register("file-field", FileFieldController)

import FilesFieldController from "./files_field_controller"
application.register("files-field", FilesFieldController)

import FilterParamsController from "./filter_params_controller"
application.register("filter-params", FilterParamsController)

import Forms__AutoSubmitController from "./forms/auto_submit_controller"
application.register("forms--auto-submit", Forms__AutoSubmitController)

import Forms__NumberInputController from "./forms/number_input_controller"
application.register("forms--number-input", Forms__NumberInputController)

import GalleryRevealController from "./gallery_reveal_controller"
application.register("gallery-reveal", GalleryRevealController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import HeroCarouselController from "./hero_carousel_controller"
application.register("hero-carousel", HeroCarouselController)

import HoverPopoverController from "./hover_popover_controller"
application.register("hover-popover", HoverPopoverController)

import Integration__FancyboxController from "./integration/fancybox_controller"
application.register("integration--fancybox", Integration__FancyboxController)

import Integration__SortablejsController from "./integration/sortablejs_controller"
application.register("integration--sortablejs", Integration__SortablejsController)

import Integration__TippyjsController from "./integration/tippyjs_controller"
application.register("integration--tippyjs", Integration__TippyjsController)

import LoopVideoController from "./loop_video_controller"
application.register("loop-video", LoopVideoController)

import MobileConfigSheetController from "./mobile_config_sheet_controller"
application.register("mobile-config-sheet", MobileConfigSheetController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OptionToggleController from "./option_toggle_controller"
application.register("option-toggle", OptionToggleController)

import OptionalFieldController from "./optional_field_controller"
application.register("optional-field", OptionalFieldController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PhotoCycleController from "./photo_cycle_controller"
application.register("photo-cycle", PhotoCycleController)

import PhotoQuantityController from "./photo_quantity_controller"
application.register("photo-quantity", PhotoQuantityController)

import PhotoSelectionController from "./photo_selection_controller"
application.register("photo-selection", PhotoSelectionController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PreviewModalController from "./preview_modal_controller"
application.register("preview-modal", PreviewModalController)

import PriceFieldController from "./price_field_controller"
application.register("price-field", PriceFieldController)

import ProductPreviewController from "./product_preview_controller"
application.register("product-preview", ProductPreviewController)

import QuickOrderSubmitController from "./quick_order_submit_controller"
application.register("quick-order-submit", QuickOrderSubmitController)

import QuickPrintPickerController from "./quick_print_picker_controller"
application.register("quick-print-picker", QuickPrintPickerController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import ResumeBannerController from "./resume_banner_controller"
application.register("resume-banner", ResumeBannerController)

import RichTextEditorController from "./rich_text_editor_controller"
application.register("rich-text-editor", RichTextEditorController)

import RolePricesController from "./role_prices_controller"
application.register("role-prices", RolePricesController)

import ScreenSwapController from "./screen_swap_controller"
application.register("screen-swap", ScreenSwapController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SearchPaletteController from "./search_palette_controller"
application.register("search-palette", SearchPaletteController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TextClampController from "./text_clamp_controller"
application.register("text-clamp", TextClampController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import UpdateController from "./update_controller"
application.register("update", UpdateController)

import VariantSelectorController from "./variant_selector_controller"
application.register("variant-selector", VariantSelectorController)
